import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  constructor() {}
  samePassword(pass1: string, pass2: string) {
    return (formGroup: FormGroup) => {
      const pw1 = formGroup.controls[pass1];
      const pw2 = formGroup.controls[pass2];

      if (pw1.value === pw2.value) {
        pw2.setErrors(null);
      } else {
        pw2.setErrors({ notSame: true });
      }
    };
  }
}
